import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {webServiceConfig} from "../config/web-service.config";
import {map} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class GroupTypeProductService {

    constructor(private http: HttpClient) { }
    getTypeProducts(brandId: any): Observable<any> {
        return this.http.get(`${webServiceConfig.webServiceUrl}group-type-products/${brandId}`).pipe(map(response => {
            return response;
        }));
    }
}
